// extracted by mini-css-extract-plugin
export default {"container":"HkUJ77","notFirstItem":"y2aod_","pimple":"OuMiQT","pimpleFullButton":"Z_5So2","pimpleHollowButton":"tq9s65","updatedIndicationText":"TG8zlA"};